import { UNITS_OF_MEASURES_FETCH } from '../action-types/units-of-measures-types';
import { Maybe } from '../../types/common';
import { TMeausureUnitEntity } from '../../types/entities';

export type TMeasureUnitReducerState = {
  entities: TMeausureUnitEntity[];
  entity: Maybe<TMeausureUnitEntity>;
  entityLoaded: boolean;
  loading: boolean;
};

const initialState: TMeasureUnitReducerState = {
  entities: [],
  entity: null,
  entityLoaded: false,
  loading: false,
};

export default function (
  state = initialState,
  action,
): TMeasureUnitReducerState {
  switch (action.type) {
    case UNITS_OF_MEASURES_FETCH.REQUEST:
    case UNITS_OF_MEASURES_FETCH.REJECTED:
      return {
        ...state,
        loading: true,
      };
    case UNITS_OF_MEASURES_FETCH.SUCCESS:
      return {
        ...state,
        entities: action.payload.data.sort(
          (entityA, entityB) => entityA.id - entityB.id,
        ),
        loading: false,
      };
    default:
      return state;
  }
}
